import { skillIconMap } from "@constants/common";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import { HeaderCardAvatar } from "@memorang/ui/src/components/HeaderCard";
import { MasteryListItem } from "@memorang/ui/src/components/MasteryListItem";
import { useTranslation } from "react-i18next";
import { Card, Divider } from "react-native-paper";
/* ----------------- Types --------------- */
import type { SectionItems } from "../../types";
import CardSkeleton from "../Skeletons/CardSkeleton";

interface Props {
	items: SectionItems;
	showStudyPackViews?: boolean;
	handleSelectTopic: (id: number) => void;
	handleShowPurchase: () => void;
	studyPackSubtitle?: string;
	handleNavigateToDetailView?: () => void;
	loading?: boolean;
}

const TopicsSection = ({
	items,
	showStudyPackViews,
	handleSelectTopic,
	handleShowPurchase,
	studyPackSubtitle,
	loading,
}: Props) => {
	const theme = useAppTheme();

	const { isMobile } = useDevice();
	const { t } = useTranslation();

	const CardHeader = () => {
		return (
			<>
				<Card.Title
					title="Study-Pack"
					left={() => {
						return <HeaderCardAvatar icon="tag-multiple-outline" />;
					}}
					subtitle={showStudyPackViews && studyPackSubtitle}
				/>
				<Divider
					style={{
						backgroundColor: theme.colors.surfaceVariant,
					}}
				/>
			</>
		);
	};

	const showCardHeader = false;
	if (loading) {
		return <CardSkeleton />;
	}

	return (
		<Card
			style={{
				borderRadius: isMobile ? 0 : 8,
				overflow: "hidden",
			}}
			accessibilityLabel={`Topics section, contains Study Packs ${studyPackSubtitle ?? ""}`}
			accessible
		>
			{showCardHeader && <CardHeader />}
			{items.map((item) => {
				if ("distribution" in item) {
					const {
						title,
						distribution,
						id,
						locked,
						numItems,
						score,
						colorScale,
					} = item;

					return (
						<MasteryListItem
							title={title}
							key={id}
							distribution={distribution}
							rightText={t("common.itemCount", { count: numItems })}
							locked={locked}
							variant="large"
							score={score}
							numItems={numItems}
							colorScale={colorScale}
							icon={skillIconMap[title]}
							onPress={
								showStudyPackViews
									? () => {
											if (locked) {
												handleShowPurchase();
											} else {
												handleSelectTopic(id);
											}
										}
									: undefined
							}
						/>
					);
				}
				return null;
			})}
			{/* <Card.Actions>
				<Button onPress={handleNavigateToDetailView} mode="text">
					View All
				</Button>
			</Card.Actions> */}
		</Card>
	);
};

export default TopicsSection;
